import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";

import ModalFormDropdown from "../../components/form/ModalFormDropdown";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import { ThousandSeparatorFormatNames } from "../../constants/dateFormats";
import { DateOrderIdentifiers } from "../../constants/dateOrders";
import skinOptions from "../../constants/skinOptions";
import debugUtils from "../../utils/debugUtils";
import preprocessorQuery from "../../utils/preprocessorQuery";

const dateOrderOptions = [
  { label: "dd/mm/yyyy", value: DateOrderIdentifiers.DayMonthYear },
  { label: "mm/dd/yyyy", value: DateOrderIdentifiers.MonthDayYear },
  { label: "yyyy-mm-dd", value: DateOrderIdentifiers.YearMonthDay }
];

const thousandsSeparatorOptions = [
  { label: ThousandSeparatorFormatNames.Comma, value: ThousandSeparatorFormatNames.Comma },
  { label: ThousandSeparatorFormatNames.Period, value: ThousandSeparatorFormatNames.Period }
];

class PreferencesAppearanceTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  componentWillReceiveProps(nextProps) {
    debugUtils.logPropChanges("modalTabWrapper", this.props, nextProps, true);
  }

  render() {
    const isIos = preprocessorQuery.isIos();
    return (
      <Fragment>
        {isIos ? (
          <ModalGroup>
            <ModalRow>
              <div style={{ paddingTop: "20px", textAlign: "center" }}>
                These settings determine how Aeon Timeline looks or behaves on your device. Changes to these settings
                will take immediate effect and will not modify your current file&apos;s data
              </div>
            </ModalRow>
          </ModalGroup>
        ) : null}
        <ModalGroup label="Text Formatting">
          <ModalRow>
            <ModalField label="Short Date Order">
              <ModalFormDropdown
                options={dateOrderOptions}
                value={this.props.dateOrder}
                onChange={this.props.onDateOrderChange}
                title="Short Date Order"
                backText="Preferences"
              />
            </ModalField>
            <ModalField label="Thousands Separator">
              <ModalFormDropdown
                options={thousandsSeparatorOptions}
                value={this.props.thousandsSeparator}
                onChange={this.props.onThousandsSeparatorChange}
                title="Thousands Separator"
                backText="Preferences"
              />
            </ModalField>
          </ModalRow>
        </ModalGroup>
        <ModalGroup label="Appearance">
          <ModalRow>
            <ModalField label="Skin" flex={6}>
              <ModalFormDropdown
                options={skinOptions}
                value={this.props.skin}
                onChange={val => this.props.onSkinChange(val, this.props.skin)}
                title="Theme"
                backText="Preferences"
              />
            </ModalField>
          </ModalRow>
        </ModalGroup>
      </Fragment>
    );
  }
}

PreferencesAppearanceTab.propTypes = {
  dateOrder: PropTypes.string.isRequired,
  thousandsSeparator: PropTypes.string.isRequired,
  skin: PropTypes.string.isRequired,

  onDateOrderChange: PropTypes.func.isRequired,
  onThousandsSeparatorChange: PropTypes.func.isRequired,
  onSkinChange: PropTypes.func.isRequired
};

export default PreferencesAppearanceTab;
